// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.exterior-info-container {
  width: 100%;
}
.exterior-info-container .no-data {
  display: flex;
  align-items: center;
  justify-content: center;
}
.exterior-info-container .no-data > p {
  font-family: "Proxima Nova", sans-serif;
  font-size: 22px;
  font-weight: 700;
  color: var(--secondary-color-3);
}`, "",{"version":3,"sources":["webpack://./src/routes/Listing/modules/ListingDetail/modules/Tabs/modules/ExteriorInfo/exteriorInfo.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;AACJ;AAAI;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;AAER;AADQ;EACI,uCAAA;EACA,eAAA;EACA,gBAAA;EACA,+BAAA;AAGZ","sourcesContent":[".exterior-info-container {\n    width: 100%;\n    .no-data {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        > p {\n            font-family: 'Proxima Nova', sans-serif;    \n            font-size: 22px;\n            font-weight: 700;\n            color: var(--secondary-color-3);\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
